// extracted by mini-css-extract-plugin
export var addToCartButton = "_lk-b";
export var arrowButtonContainer = "_lk-9";
export var arrowButtonIcon = "_lk-a";
export var carouselArrowButton = "_lk-6";
export var carouselElementContainer = "_lk-1";
export var left = "_lk-7";
export var productDisplayCarouselContainer = "_lk-0";
export var productTileContainer = "_lk-2";
export var productTileImage = "_lk-4";
export var productTileImageContainer = "_lk-3";
export var productTileTitle = "_lk-5";
export var right = "_lk-8";
export var sliderOverflow = "_lk-c";